import { ModalWindow, Span } from "@tblabs/truffle";
import { MenuButton } from "../Components/DeviceMenuButton";


export class Menu extends ModalWindow
{
    public Result = new Span("...");

    constructor(windowTitle: string, items: Record<string, () => any>)
    {
        super(windowTitle, true, true, true);

        this.Shutter.Blur(0.8)
            .OnClick(() => this.CloseWindow());

        this.content.TextAlignCenter()
            .Append(
                ...Object.entries(items)
                    .map(([button, action]) =>
                    {
                        const icon = button.split(" ")[0];
                        const label = button.split(" ")[1];
                        return new MenuButton(icon, label, action)
                            .OnClick(action);
                    })
            );

        this.footer.TextAlignCenter().Append(
            this.Result
        );

        this.OpenWindow();
    }
}
